import useCustomHook from '@/hooks/useCustomHook';
import { shuffleList } from '@/modules/gameUtils/random';
import { useEffect } from 'react';

export default function useFillGapsPage({ page, activityActions }) {
  const { state, actions } = useCustomHook({
    defaultState: {
      lines: [],
      options: [],
      answers: [],
      draggedOptionId: null,
      answered: false,
      correct: false,
      doPlayOption: null,
    },
    actions: {
      onDragStart: ({ active }) => {
        actions.setState({
          draggedOptionId: active.id,
          doPlayOption: active.id,
        });
      },
      onDragEnd: ({ active, over }) => {
        let stateChanges = {
          draggedOptionId: null,
        };
        if (over) {
          const answers = state.answers.filter(
            (answer) =>
              !(answer.answerId == over.id) && !(answer.id == active.id)
          );

          const answer = {
            id: active.id,
            correct: active.id == over.id,
            answerId: over.id,
            pageId: page.id,
          };
          const gaps = state.gaps;

          answers.push(answer);
          stateChanges = {
            ...stateChanges,
            answers,
            answered: answers.length === gaps.length,
            correct: answers.every((a) => a.correct),
          };
          if (stateChanges.answered) {
            activityActions.onActivityProgress(page.id, answers);
          }
        }

        actions.setState({
          ...stateChanges,
        });
      },
      onOptionPlayed: ({}) => {
        actions.setState({
          doPlayOption: null,
        });
      },
    },
  });

  useEffect(() => {
    if (page.data) {
      let gapIndex = 1;
      const lines = [];
      const gaps = [];
      for (const line of page.data.textWithGaps) {
        const parts = line.split(/(XXXX)/).map((part) => {
          if (part === 'XXXX') {
            gaps.push(gapIndex);
            return {
              isGap: true,
              id: gapIndex++,
            };
          }
          return {
            isGap: false,
            text: part,
          };
        });
        lines.push({
          parts,
        });
      }
      const options = shuffleList(page.data.options);
      actions.setState({
        lines,
        gaps,
        options,
      });
    }
  }, [page.data]);

  return { state, actions };
}
